import { render } from "./App.vue?vue&type=template&id=2603396e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2603396e&lang=css"

import exportComponent from "/home/hyz-027/myprojects/vue/book-a-pooja-customer-side/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__